<template>
  <b-row>
    <b-col cols="12" class="mb-1">
      <h3 class="mb-0">
        หลักฐานประกอบการแจ้งเบาะแส
      </h3>
    </b-col>
    <b-row
      v-for="file in this.attachFiles"
      :key="file.attachId"
      class="col-12 m-1"
    >
      <b-col cols="5">
        <a :href="file.filePath" :download="file.fileName" target="_blank">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="feather feather-arrow-down-circle"
          >
            <circle cx="12" cy="12" r="10" />
            <polyline points="8 12 12 16 16 12" />
            <line x1="12" y1="8" x2="12" y2="16" />
          </svg>
          {{ file.fileName }}
        </a>
      </b-col>
      <b-col cols="5" class="d-flex justify-content-center">
        {{ file.masterDescription }}
      </b-col>
      <b-col cols="1" class="d-flex justify-content-center">
        {{ file.downloadCount }}
      </b-col>
      <b-col cols="1" class="d-flex justify-content-center">
        <a
          v-if="isAdminRole()"
          href="#"
          class="text-danger"
          @click="emitDeleteFile(file.attachId)"
        >
          <feather-icon icon="Trash2Icon" size="24" />
        </a>
      </b-col>
    </b-row>

    <b-col cols="12 mt-2">
      <h4>แนบเอกสารเพิ่มเติม</h4>
    </b-col>
    <b-col md="6">
      <b-form-select v-model="selected" :options="attachTypes" class="" />
    </b-col>
    <b-col md="6">
      <b-form-file
        @change="onUploadFileChanged"
        ref="file-input"
        multiple
        placeholder="Choose a file or drop it here..."
        drop-placeholder="Drop file here..."
      />
    </b-col>
    <b-col md="12" class="mt-2 d-flex justify-content-center">
      <!-- <b-button variant="primary"
          @click="onUploadBtnClicked"
        >
          Upload
        </b-button> -->
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormSelect,
  BFormTextarea,
  BFormCheckboxGroup,
  BFormCheckbox,
  BCardText,
  BFormFile,
} from "bootstrap-vue";
import * as storeFileUpload from "@/store/api/fileUpload/index.js";
import * as storeMaster from "@/store/api/master/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import appsettings from "@/store/app-settings";
export default {
  components: {
    // ValidationProvider,
    // ValidationObserver,
    // FormWizard,
    // TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckboxGroup,
    BFormCheckbox,
    BCardText,
    // vSelect,
    // BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    // ToastificationContent,
    BFormSelect,
    BForm,
    BButton,
    BCard,
    BFormTextarea,
    BFormFile,
    storeFileUpload,
    storeMaster,
    userData,
  },
  props: {
    attachFiles: [],
    keyId: String,
  },
  data() {
    return {
      attachTypes: [],
      selected: 13,
      files: [],
    };
  },
  created() {
    //console.log('created')
    this.getClueFileType();
  },
  methods: {
    isAdminRole() {
      if (userData.selectedRole() === appsettings.complaintRoleId.admin) {
        return true;
      }
      return false;
    },
    getClueFileType() {
      const _this = this;
      storeMaster
        .getClueMasterByType()
        .then(function(response) {
          // handle success
          //console.log('then', response);

          var convertData = response.data.data.map(function(item, index) {
            return {
              value: item.masterId,
              text: item.description,
            };
          });

          _this.attachTypes = convertData;
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    getFileType() {
      const _this = this;
      storeMaster
        .getMasterByType()
        .then(function(response) {
          // handle success
          //console.log('then', response);

          var convertData = response.data.data.map(function(item, index) {
            return {
              value: item.masterId,
              text: item.description,
            };
          });

          _this.attachTypes = convertData;
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
        });
    },
    onUploadBtnClicked() {
      console.log("this.files", this.attachFiles);
    },
    onUploadFileChanged(e) {
      const selectedFiles = e.target.files;
      if (selectedFiles === null || selectedFiles === undefined || selectedFiles.length <= 0) {
        return;
      }

      const _this = this;
      var isMissing = this.onValidateExtensionFiles(selectedFiles, null);
      if (isMissing === true) {
        return;
      }

      selectedFiles.forEach(function(value, index) {
        _this.createBase64Image(value);
      });
    },
    createBase64Image(fileObject) {
      const _this = this;

      const reader = new FileReader();

      const fileName = fileObject.name;
      const fileSize = fileObject.size;

      reader.onload = (e) => {
        const fileBase64 = e.target.result;
        console.log(
          "fileName=",
          fileName,
          "fileSize=",
          fileSize,
          "fileType=",
          _this.selected
        );
        this.$refs["file-input"].reset();

        const data = [
          {
            fileName: fileName,
            fileSize: fileSize,
            fileBase64: fileBase64,
            fileType: _this.selected,
            masterId: 3,
            keyId: _this.keyId,
            typeUserUpload: 1,
            userId: userData.userId(),
          },
        ];
        storeFileUpload
          .uploadFileWithType(data)
          .then(function(response) {
            // handle success
            console.log(response);
            response.data.data.forEach(function(value, index) {
              console.log("emit upload", value);
              //this.$emit('handleSend', id)
              _this.emitUploadFile(value);
            });
          })
          .catch(function(error) {
            // handle error
            console.log("error", error);
          })
          .then(function() {
            // always executed
          });
        //console.log('base64', base64)
      };

      reader.readAsDataURL(fileObject);
    },
    emitUploadFile(file) {
      console.log("handleUpload");

      this.attachFiles.push(file);
      //this.$emit('handle-upload', file)
    },
    emitDeleteFile(id) {
      console.log("emitDeleteFile", id);
      const _this = this;

      this.$swal({
        title: "ยืนยันการลบข้อมูล?",
        text: "",
        icon: "success",
        showCancelButton: true,
        confirmButtonText: "บันทึก",
        cancelButtonText: "ยกเลิก",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-primary ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          storeFileUpload
            .DeleteFile(id, userData.userId())
            .then(function(response) {
              // handle success
            })
            .catch(function(error) {
              // handle error
            })
            .then(function() {
              // always executed
            });

          const file = this.attachFiles.find(function(value) {
            return value.attachId === id;
          });

          var filteredAry = this.attachFiles.filter((o) => o.attachId != id);

          this.attachFiles = filteredAry;

          //this.$emit('handle-delete', id)
        }
      });
    },
    onValidateExtensionFiles(selectedFiles, section) {
      console.log(`onvalidateextensionfiles.section`, section);
      let isMissing = false;

      // เช็คว่าไฟล์ที่อัพโหลดมีสกุลไฟล์หรือไม่
      // ถ้าไม่มีให้แสดง popup แจ้งเตือน
      const arrNoExtension = Object.values(selectedFiles).filter((file) => {
        return (
          file.type === null || file.type === undefined || file.type === ""
        );
      });

      if (arrNoExtension.length > 0) {
        isMissing = true;
        this.$swal({
          html:
            "<div>ไม่สามารถอัพโหลดไฟล์ที่ไม่มีสกุลไฟล์ได้<br />กรุณาตรวจสอบไฟล์ของท่านก่อนทำการอัพโหลด</div>",
          icon: "warning",
          showCancelButton: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        }).then((result) => {
          try {
            this.$refs["file-input"].reset();
          } catch (ex) {
            console.log(ex);
          }
        });
      }

      return isMissing;
    },
  },
};
</script>
